<template>
  <div>
    <vs-card>
      <DataListMensageria
        :subjectPermission="subjectPermission"
        @newEvent="novoAssunto()"
      />
    </vs-card>
  </div>
</template>

<script>
import DataListMensageria from './component/mensageria-data-list.vue';

export default {
  data() {
    return {
      subjectPermission: 'Mensageria',
    };
  },
  components: {
    DataListMensageria,
  },
  methods: {
    novoAssunto() {
      this.$router.push('mensageria/novo');
    },
  },
};
</script>
